
//
// Generates a unique id.
//
export function uuid():  string {
    return crypto.randomUUID();
}